<template>
  <div class="filter-item" ref="main">
    <v-card>
      <v-toolbar dense :color="`${$vuetify.theme.themes.light.primary}`">
        <v-toolbar-title>
          <h6>
            {{ this.showFilter.sectionKey }}.{{ this.showFilter.fieldKey }}
          </h6>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-select
          v-model="select_state"
          hide-details
          dense
          class="f-s-12 m-l-5"
          :items="states"
          item-value="text"
          @change="updateLeadFilter($event)"
        >
        </v-select>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              size="20"
              class="operation-btn"
              @click="onImportFile"
              >mdi-upload</v-icon
            >
          </template>
          <span>Import</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              size="20"
              class="operation-btn"
              @click="exportFile"
              >mdi-download</v-icon
            >
          </template>
          <span>Export</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              size="20"
              class="operation-btn-delete"
              @click="deleteFileCard"
              >mdi-close</v-icon
            >
          </template>
          <span>Delete</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-combobox
          v-if="showAdd"
          hide-details
          outlined
          v-model="parameter"
          :items="resultItems"
          @click.once="onClickSearch"
          @update:search-input="onClickInput"
          :placeholder="select_label"
          persistent-placeholder
          append-outer-icon="mdi-plus"
          @click:append-outer="dialog.visible = true"
        ></v-combobox>
        <v-combobox
          v-if="deleteById"
          hide-details
          outlined
          v-model="parameter"
          :items="resultItems"
          :placeholder="select_label"
          append-outer-icon="mdi-minus"
          @click:append-outer="deleteFilterById"
          persistent-placeholder
          @input.native="parameter = $event.target.value"
        ></v-combobox>
      </v-card-text>
    </v-card>
    <input id="refFile" style="display: none" type="file" accept="text/plain" @change="fileLoad" />
    <sure-delete-dialog
            :dialog="dialog"
            :deleteItem="deleteItem"
            :operatedBy="operatedBy"
            :token="showFilter.token"
            :deleteId="deleteId"
            @deleteItemSuccessful="deleteItemSuccessful"
            @deleteSuccessful="deleteSuccessful"
            @deletFailure="deletFailure"
            :tips="tips"
          ></sure-delete-dialog>
    <add-filter-dialog
      :dialog="dialog"
      @getParameterValue="getParameterValue"
      ref="addOneItem"
    ></add-filter-dialog>
    <add-successful-dialog :dialog="dialog"></add-successful-dialog>
    <add-failure-dialog
      :dialog="dialog"
      :failureMessage="failureMessage"
    ></add-failure-dialog>
    <import-successful-dialog
      :dialog="dialog"
      :successfulMessage="successfulMessage"
    ></import-successful-dialog>
    <v-dialog
      v-model="isLoading"
      overlay-color="#2296F3"
      overlay-opacity="0.6"
      persistent
      width="300"
    >
      <v-card>
        <v-card-text style="height: 36px !important">
          Please stand by
          <v-progress-linear indeterminate color="#009688"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { FilterApi } from '@/api/pandaria'
import AddFilterDialog from '@/components/panda/setting/dialog/AddFilterDialog.vue'
import AddSuccessfulDialog from '@/components/panda/setting/dialog/AddSuccessfulDialog.vue'
import AddFailureDialog from '@/components/panda/setting/dialog/AddFailureDialog.vue'
import SureDeleteDialog from '@/components/panda/filter/SureDeleteDialog.vue'
import ImportSuccessfulDialog from '@/components/panda/setting/dialog/ImportSuccessfulDialog'
import { Tool, DataType } from '@/util/index'

const tool = new Tool()
export default {
  name: 'FilterCard',
  components: {
    AddFilterDialog,
    AddSuccessfulDialog,
    AddFailureDialog,
    SureDeleteDialog,
    ImportSuccessfulDialog
  },
  props: ['showFilter', 'operatedBy', 'roleId'],
  data: () => ({
    items: [],
    states: DataType.statesValue,
    select_state: '',
    select_label: '',
    dialog: {
      visible: false,
      successful: false,
      failure: false,
      inputSuccessful: false,
      showDelete: false,
      showProgress: false
    },
    parameterValue: 0,
    failureMessage: '',
    parameter: '',
    resultItems: [],
    deleteById: false,
    showAdd: true,
    deleteId: 0,
    deleteItem: {},
    successfulMessage: '',
    tips: '',
    isLoading: false,
    resultList: []
  }),
  created () {
    this.select_state = this.states.find(
      (e) => e.value === this.showFilter.operator
    )?.text
    this.select_label = 'TOTAL ' + this.showFilter.valueCount + ' ITEMS'
  },
  watch: {
    showFilter (val) {
      this.select_state = this.states.find(e => e.value === val.operator)?.text
      this.select_label = 'TOTAL ' + val.valueCount + ' ITEMS'
    },
    parameter (val) {
      const $this = this
      if (val === $this.select_label) {
        return false
      } else if (tool.isNotEmpty(val)) {
        const arr1 = $this.resultList.filter(ele => {
          if (ele.value === val) {
            $this.showAdd = false
            $this.deleteById = true
            return ele
          }
        })
        $this.deleteId = arr1.length > 0 ? arr1[0].id : null
      } else if (tool.isEmpty(val)) {
        $this.showAdd = true
        $this.deleteById = false
      }
    }
  },
  methods: {
    deleteSuccessful () {
      for (let i = 0; i < this.resultList.length; i++) {
        if (this.resultList[i].id === this.deleteId) {
          this.resultList.splice(i, 1)
        }
      }
      this.parameter = ''
      if (tool.isEmpty(this.resultList)) {
        this.resultList = [{ value: 'Search results are empty' }]
        this.resultItems = this.resultList.map(ele => { return ele.value })
      } else {
        this.resultItems = this.resultList.map(ele => { return ele.value })
      }
      this.select_label = 'TOTAL ' + (this.showFilter.valueCount - 1) + ' ITEMS'
      this.showAdd = true
      this.deleteById = false
      this.onClickSearch()
    },
    getParameterValue (data) {
      this.parameterValue = data
      this.addFilterValue()
    },
    addFilterValue () {
      const $this = this
      const input = {
        filterId: $this.showFilter.id,
        value: $this.parameterValue,
        operatedBy: JSON.stringify($this.operatedBy),
        token: $this.showFilter.token
      }
      FilterApi.saveRiskFilterValue(
        input,
        function () {
          $this.dialog.visible = false
          $this.dialog.successful = true
          $this.showFilter.valueCount = $this.showFilter.valueCount + 1
          $this.$refs.addOneItem.parameterValue = ''
          const input = {
            filterId: $this.showFilter.id,
            value: '',
            token: $this.showFilter.token
          }
          $this.getListRiskFilterValue(input)
        },
        function (result) {
          $this.dialog.visible = false
          $this.failureMessage = result.message
          $this.dialog.failure = true
          $this.$refs.addOneItem.parameterValue = ''
        }
      )
    },
    updateLeadFilter (e) {
      const operatorText = this.states.find(ele => ele.value === this.showFilter.operator)?.text
      if (e === operatorText) {
      } else {
        const $this = this
        const currentOperator = this.states.find(ele => ele.text === e).value
        const data = {
          id: $this.showFilter.id,
          sectionKey: $this.showFilter.sectionKey,
          fieldKey: $this.showFilter.fieldKey,
          operator: currentOperator
        }
        const input = {
          roleId: $this.roleId,
          filter: data,
          operatedBy: JSON.stringify($this.operatedBy),
          token: $this.showFilter.token
        }
        $this.$emit('updateLeadFilterState', input, $this.showFilter)
      }
    },
    onClickSearch () {
      const $this = this
      const input = {
        filterId: $this.showFilter.id,
        value: '',
        token: $this.showFilter.token
      }
      $this.getListRiskFilterValue(input)
    },
    onClickInput (value) {
      const $this = this
      const input = {
        filterId: $this.showFilter.id,
        token: $this.showFilter.token
      }
      if (tool.isNotEmpty(value)) {
        input.value = value
        $this.getListRiskFilterValue(input)
      }
    },
    getListRiskFilterValue (input) {
      const $this = this
      FilterApi.getListRiskFilterValue(input, function (result) {
        if (tool.isEmpty(result)) {
          $this.resultList = [{ value: 'No results' }]
          $this.resultItems = $this.resultList.map(ele => { return ele.value })
        } else {
          if (result.filterValues instanceof Array) {
            $this.resultList = result.filterValues
            if (result.count > 20) {
              $this.select_label = 'TOTAL ' + (result.count) + ' ITEMS'
              $this.resultList = [{ value: 'Total ' + (result.count) + ' items' }]
              $this.resultItems = $this.resultList.map(item => { return item.value })
            } else {
              $this.$set($this.resultItems, 0, { value: 'Total ' + (result.count) + ' items' })
              $this.select_label = 'TOTAL ' + (result.count) + ' ITEMS'
              $this.resultItems = result.filterValues.map(item => { return item.value })
              if (tool.isNotEmpty($this.parameter) && $this.parameter !== $this.select_label) {
                $this.showAdd = false
                $this.deleteById = true
                const arr = $this.resultList.filter(item => {
                  if (item.value === $this.parameter) {
                    return item
                  }
                })
                $this.deleteId = arr.length > 0 ? arr[0].id : null
              }
            }
          } else {
            $this.resultList = [
              { value: 'Total ' + (result.count) + ' items' }
            ]
            $this.resultItems = $this.resultList.map(ele => { return ele.value })
          }
          $this.$forceUpdate()
        }
      }, err => {
        $this.$forceUpdate()
        $this.select_label = 'TOTAL ' + 0 + ' ITEMS'
        $this.resultList = [{ value: 'No results' }]
        $this.resultItems = $this.resultList.map(ele => { return ele.value })
        $this.failureMessage = err.message
        $this.dialog.failure = true
      })
    },
    deleteFilterById () {
      this.tips = 'Are you sure to DELETE the value?'
      this.dialog.showDelete = true
      // if (this.resultItems.length === 1) {
      //   this.deleteCard()
      // } else {
      //   this.dialog.showDelete = true
      // }
    },
    deleteItemSuccessful () {
      this.$emit('getList')
    },
    deleteCard () {
      const $this = this
      const input = {
        id: $this.deleteItem.id,
        operatedBy: JSON.stringify($this.operatedBy),
        token: $this.showFilter.token
      }
      FilterApi.deleteRiskFilter(
        input,
        () => {
          $this.dialog.successful = true
          $this.$emit('getList')
        },
        (err) => {
          $this.failureMessage = err.message
          $this.dialog.failure = true
        }
      )
    },
    deletFailure (message) {
      this.failureMessage = message
      this.dialog.failure = true
    },
    deleteFileCard () {
      const $this = this
      this.deleteItem = this.showFilter
      this.tips = 'Are you sure to DELETE ALL values?'
      if (this.showFilter.valueCount === 0) {
        $this.deleteCard()
      } else {
        $this.dialog.showDelete = true
      }
    },
    onImportFile () {
      if (this.select_state === 'EQUAL' || this.select_state === 'NOT EQUAL') {
        this.failureMessage = 'This option is not allowed'
        this.dialog.failure = true
      } else {
        const refFile = document.getElementById('refFile')
        refFile.dispatchEvent(new MouseEvent('click'))
      }
    },
    fileLoad () {
      const refFile = document.getElementById('refFile')
      const selectedFile = refFile.files[0]
      const size = selectedFile.size
      const value = selectedFile.name.lastIndexOf('.')
      const strType = selectedFile.name.substring(value)
      if (strType !== '.txt') {
        this.failureMessage = 'You cannot import files of this type'
        this.dialog.failure = true
      } else if (size > 1048576) {
        this.failureMessage = 'Uploaded file should less than 1MB'
        this.dialog.failure = true
      } else {
        const $this = this
        $this.isLoading = true
        const request = new FormData()
        request.append('file', selectedFile)
        request.append('operatedBy', JSON.stringify($this.operatedBy))
        request.append('filterId', $this.showFilter.id)
        FilterApi.importRiskFilterValue($this.showFilter.token,
          request,
          function (result) {
            $this.isLoading = false
            $this.successfulMessage = 'Total: ' + result.countOfUpload + ', Success: ' + result.countOfSuccess + ', Duplicate: ' + result.countOfDuplicate
            $this.dialog.inputSuccessful = true
            $this.select_label = 'TOTAL ' + ($this.showFilter.valueCount + result.countOfSuccess) + ' ITEMS'
            document.getElementById('refFile').value = null
          },
          function (err) {
            $this.isLoading = false
            $this.failureMessage = err.message
            $this.dialog.failure = true
          }
        )
      }
      refFile.value = ''
    },
    exportFile () {
      const $this = this
      const request = new FormData()
      request.append('filterId', $this.showFilter.id)
      request.append('operatedBy', JSON.stringify($this.operatedBy))
      FilterApi.exportRiskFilterValue($this.showFilter.token, request,
        (res) => {
          if (tool.isNotEmpty(res.downloadUrl)) {
            $this.dialog.successful = true
            window.open(res.downloadUrl)
          }
        },
        () => {
          $this.failureMessage = 'Failure'
          $this.dialog.failure = true
        }
      )
    }
  }
}
</script>

<style scoped>
.filter-item {
  border: 1px solid #ccc;
  margin: 8px;
  display: inline-block;
  width: 32%;
}
.operation-btn {
  margin-top: 6px;
  margin-left: 6px;
}
.operation-btn-delete {
  margin-top: 6px;
  margin-left: 6px;
  color: red;
}
.select {
  padding: 0px;
  font-size: 16px;
  font-weight: bolder;
  vertical-align: -1px;
  display: inline-block;
  direction: rtl;
  outline: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.state {
  padding: 6px;
  font-weight: bolder;
  font-size: 13px;
  width: 324px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.items {
  height: 38px !important;
}
.total-items {
  background-color: #fff;
  height: 38px;
  width: 100%;
  padding: 5px;
  line-height: 30px;
  font-size: 16px;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
}
</style>
